export enum Color {
  Red = '#F44336',
  Pink = '#E91E63',
  Purple = '#9C27B0',
  DeepPurple = '#673AB7',
  Indigo = '#3F51B5',
  Blue = '#2196F3',
  LightBlue = '#03A9F4',
  Cyan = '#00BCD4',
  Teal = '#009688',
  Green = '#4CAF50',
  LightGreen = '#2fff0f',
  Lime = '#CDDC39',
  Yellow = '#FFEB3B',
  Amber = '#FFC107',
  Orange = '#FF9800',
  DeepOrange = '#FF5722',
  Brown = '#795548',
  RedGrey = '#635c5c',
  BlueGrey = '#607D8B',
  Grey = '#9E9E9E',
  White = '#FFFFFF',
  Black = '#000000'
}
